"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _typography = require("@vds-core/typography");

var _config = _interopRequireDefault(require("./config"));

var _index = require("../../index");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fonts = require("../../fonts");

var propTypes = {
  size: _propTypes["default"].oneOf(['XSmall', 'small', 'medium', 'large', 'XLarge', '2XLarge'])
};

var Title = function Title(props) {
  function getTitleFontWeight(typescale, bold, size) {
    //always bold
    return 700;
  }

  return /*#__PURE__*/_react["default"].createElement(_typography.Title, (0, _extends2["default"])({}, props, {
    size: props.size,
    typescale: _index.TypographyConfig.getTypescale(),
    getFontWeight: getTitleFontWeight,
    config: _config["default"],
    fontsConfig: _fonts.Fonts
  }));
};

var _default = Title;
exports["default"] = _default;